import React, { useState } from "react";
import Modal from "react-modal";
import logo from "./kc.png";
import logo1 from "./kc.jpg";
import logo2 from "./kc1.jpg";
import logo3 from "./kc2.jpg";
import logo4 from "./kc3.avif";
import logo5 from "./kc4.jpg";
import logo6 from "./kc4.jpg";

function Contact() {
  const images = [
    { imageUrl: logo }, // Add more images with the same structure
    { imageUrl: logo1 },
    { imageUrl: logo2 },
    { imageUrl: logo3 },
    { imageUrl: logo4 },
    { imageUrl: logo5 },
    { imageUrl: logo6 },
    // Add more image URLs here
  ];

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalIsOpen(false);
  };

  return (
    <div className="container mx-auto p-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4">
        {images.map((image, index) => (
          <div
            key={index}
            className="group relative cursor-pointer overflow-hidden transform transition-transform hover:scale-105"
            onClick={() => openModal(image.imageUrl)}
          >
            <img
              src={image.imageUrl}
              alt={`Image ${index + 1}`}
              className="w-full h-auto rounded-lg"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 flex items-center justify-center text-white text-opacity-0 group-hover:text-opacity-100 transition-opacity">
              Click to View
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Image Modal"
        ariaHideApp={false}
      >
        <button
          className="bg-red-700 p-2 rounded-md text-white"
          onClick={closeModal}
        >
          Close Image
        </button>
        {selectedImage && (
          <img
            src={selectedImage}
            alt="Selected Image"
            className="w-full h-auto rounded-lg"
          />
        )}
      </Modal>
    </div>
  );
}

export default Contact;
